import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardHeader } from "reactstrap";

import DeleteModal from "../../../../components/common/DeleteModal";

import DataTable from "react-data-table-component";
import { withTranslation } from "react-i18next";
import CustomAddButton from "../../../../components/common/CustomAddButton";
import CustomColumnHeader from "../../../../components/common/CustomColumnHeader";
import CustomSearchInput from "../../../../components/common/CustomSearchInput";
import CustomTooltipWrapper from "../../../../components/common/CustomTooltipWrapper";
import Loader from "../../../../components/common/Loader";
import NoRecords from "../../../../components/common/NoRecords";
import AddLocationModal from "../../../../components/pages/settings/AddLocationModal";
import { getColumnDetail } from "../../../../helpers/utils";
import { addLocation, deleteLocation, editLocation, getLocations } from "../../../../store/locations/actions";

const AuctionLocation = ({ t }) => {
  const dispatch = useDispatch();
  const { data: locationData, total: totalLocations } = useSelector((state) => state.Locations);

  const [locationListLoader, setLocationListLoader] = useState(false);
  const [isDeleteLocationModalOpen, setIsDeleteLocationModalOpen] = useState(false);
  const [isAddLocationModalOpen, setIsAddLocationModalOpen] = useState(false);
  const [languageDeleteLoader, setLocationDeleteLoader] = useState(false);
  const [locationSaveLoader, setLocationSaveLoader] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [locationPayload, setLocationPayload] = useState({
    search: "",
    page: 1,
    limit: 10,
    filter: {
      id__icontains: "",
      code__icontains: "",
      [getColumnDetail("location_name_en__icontains", "location_name_pt__icontains")]: "",
      // location_name__icontains: "",
    },
  });

  const [sortingOrder, setSortingOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");

  // setting title of the page
  document.title = `Veritas | ${t("sidebarMenu.locations")}`;

  // handle sorting functionality
  useEffect(() => {
    if (orderBy !== "" && sortingOrder !== "")
      setLocationPayload((prevState) => ({
        ...prevState,
        sort: sortingOrder === "asc" ? orderBy : sortingOrder === "desc" ? `${"-" + orderBy}` : "",
      }));
  }, [orderBy, sortingOrder]);

  const handleGetLocationList = useCallback(
    (locationPayload) => {
      setLocationListLoader(true);
      dispatch(getLocations(locationPayload))
        .then((res) => {
          if (res) {
            //
          } else {
            //
          }
          setLocationListLoader(false);
        })
        .catch((error) => {
          setLocationListLoader(false);
        });
    },
    [dispatch]
  );

  useEffect(() => {
    handleGetLocationList(locationPayload);
  }, [handleGetLocationList, locationPayload]);

  const handleConfirmBtn = () => {
    setLocationDeleteLoader(true);
    dispatch(deleteLocation(selectedRow))
      .then((res) => {
        if (res) {
          //
          handleGetLocationList(locationPayload);
          setIsDeleteLocationModalOpen(false);
        } else {
          //
        }
        setLocationDeleteLoader(false);
      })
      .catch((error) => {
        setLocationDeleteLoader(false);
        setIsDeleteLocationModalOpen(false);
      });
  };

  const handleSaveLocation = (values, validation) => {
    setLocationSaveLoader(true);
    if (selectedRow && selectedRow.id) {
      // dispatch for editing page
      dispatch(editLocation({ id: selectedRow.id, values }))
        .then((res) => {
          if (res) {
            handleGetLocationList(locationPayload);
            validation.resetForm();
            setIsAddLocationModalOpen(false);
            //
          } else {
            //
          }
          setLocationSaveLoader(false);
        })
        .catch((error) => {
          setIsAddLocationModalOpen(false);
          setLocationSaveLoader(false);
        });
    } else {
      // dispatch for adding new language
      dispatch(addLocation(values))
        .then((res) => {
          if (res) {
            handleGetLocationList(locationPayload);
            validation.resetForm();
            setIsAddLocationModalOpen(false);
            //
          } else {
            //
          }
          setLocationSaveLoader(false);
        })
        .catch((error) => {
          setIsAddLocationModalOpen(false);
          setLocationSaveLoader(false);
        });
    }
  };

  // handle page change
  const handlePageChange = (value) => {
    setLocationPayload((prevState) => ({
      ...prevState,
      page: value,
    }));
  };

  // handle rows per page change
  const handleRowsPerPageChange = (value) => {
    setLocationPayload((prevState) => ({
      ...prevState,
      limit: value,
    }));
  };

  const locationDeleteHandler = (row) => {
    setIsDeleteLocationModalOpen(true);
    setSelectedRow(row.id);
  };

  const locationEditHandler = (row) => {
    setIsAddLocationModalOpen(true);
    setSelectedRow(row);
  };

  const handleCloseBtn = () => {
    setIsDeleteLocationModalOpen(false);
  };

  const handleLocationModalOpen = () => {
    setSelectedRow(null);
    setIsAddLocationModalOpen(true);
  };

  const handleLocationModalClose = () => {
    setIsAddLocationModalOpen(false);
  };

  const columns = [
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          <div className="table-column-title mb-2">{t("common.id")}</div>
          <CustomSearchInput
            columnWise={true}
            columnSearchKey="id__icontains"
            className="column-search-input"
            payload={locationPayload}
            setPayload={setLocationPayload}
          />
        </div>
      ),
      selector: (row) => row.id,
      minWidth: "150px",
    },
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          {/* <div className="table-column-title mb-2">{t("common.code")}</div> */}
          <CustomColumnHeader
            columnTitle={t("common.code")}
            sortable
            sortableKey="code"
            orderBy={orderBy}
            sortingOrder={sortingOrder}
            setOrderBy={setOrderBy}
            setSortingOrder={setSortingOrder}
          />
          <CustomSearchInput
            columnWise={true}
            columnSearchKey="code__icontains"
            className="column-search-input"
            payload={locationPayload}
            setPayload={setLocationPayload}
          />
        </div>
      ),
      selector: (row) => row.code,

      minWidth: "220px",
    },
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          {/* <div className="table-column-title mb-2">
            {t("common.description")}
          </div> */}
          <CustomColumnHeader
            columnTitle={`${t("common.description")} ${" "} ${t("common.pt")}`}
            sortable
            sortableKey="location_name_pt"
            orderBy={orderBy}
            sortingOrder={sortingOrder}
            setOrderBy={setOrderBy}
            setSortingOrder={setSortingOrder}
          />
          <CustomSearchInput
            columnWise={true}
            columnSearchKey="location_name_pt__icontains"
            className="column-search-input"
            payload={locationPayload}
            setPayload={setLocationPayload}
          />
        </div>
      ),
      selector: (row) => row.location_name_pt || "-",
      // selector: (row) => row.location_name,
      minWidth: "350px",
    },
    {
      name: (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          {/* <div className="table-column-title mb-2">
            {t("common.description")}
          </div> */}
          <CustomColumnHeader
            columnTitle={`${t("common.description")} ${" "} ${t("common.en")}`}
            sortable
            sortableKey="location_name_en"
            orderBy={orderBy}
            sortingOrder={sortingOrder}
            setOrderBy={setOrderBy}
            setSortingOrder={setSortingOrder}
          />
          <CustomSearchInput
            columnWise={true}
            columnSearchKey={"location_name_en__icontains"}
            className="column-search-input"
            payload={locationPayload}
            setPayload={setLocationPayload}
          />
        </div>
      ),
      selector: (row) => row.location_name_en || "-",
      // selector: (row) => row.location_name,
      minWidth: "350px",
    },
    {
      name: (
        <div className="table-actions font-weight-bold fs-14 table-column-container py-4">
          <div className="table-column-title mb-2">{t("common.actions")}</div>
        </div>
      ),
      selector: (row) => (
        <div className="font-weight-bold fs-14 table-column-container py-4">
          <div className="table-column-title mb-2">
            <div className="table-actions">
              <button
                type="button"
                className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle light-dark-mode shadow-none"
                onClick={() => locationEditHandler(row)}
              >
                <CustomTooltipWrapper target={`tooltip-${row?.id}-edit`} tooltipBody={t("common.edit")} />
                <i className="ri-pencil-fill fs-18" id={`tooltip-${row?.id}-edit`} />
              </button>
              <button
                type="button"
                className="btn btn-icon btn-topbar btn-ghost-primary rounded-circle light-dark-mode shadow-none"
                onClick={() => locationDeleteHandler(row)}
              >
                <CustomTooltipWrapper target={`tooltip-${row?.id}-delete`} tooltipBody={t("common.delete")} />
                <i className=" ri-delete-bin-fill fs-18" id={`tooltip-${row?.id}-delete`} />
              </button>
            </div>
          </div>
        </div>
      ),

      minWidth: "140px",
      center: true,
    },
  ];

  return (
    <>
      <div className="page-content layout-main-container">
        <div className="container-header">
          <CustomSearchInput
            className="custom-search-input"
            payload={locationPayload}
            setPayload={setLocationPayload}
          />
          <div className="contain-header-right">
            <CustomAddButton
              color="success"
              onClick={handleLocationModalOpen}
              btnTitle={`${t("common.addTitle", {
                module: `${t("settings.auctions.locations.location")}`,
              })}`}
            />
          </div>
        </div>
        <Card className="container-body">
          {locationListLoader ? <Loader /> : null}
          <CardHeader className="table-title">{t("sidebarMenu.locations")}</CardHeader>
          <DataTable
            fixedHeader
            className="data-table"
            // selectableRows
            columns={columns}
            data={[...locationData]}
            pagination
            paginationServer
            paginationTotalRows={totalLocations}
            noDataComponent={<NoRecords />}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onChangePage={handlePageChange}
            paginationComponentOptions={{
              rowsPerPageText: t("common.rowsPerPage"),
              rangeSeparatorText: t("common.rangeSeparator"),
            }}
            persistTableHead
          />
        </Card>
      </div>

      {/* to add /edit languages */}
      <AddLocationModal
        isModalOpen={isAddLocationModalOpen}
        location={selectedRow}
        onCancel={handleLocationModalClose}
        onSave={handleSaveLocation}
        loader={locationSaveLoader}
      />

      {/* delete modal for languages */}
      <DeleteModal
        title={`${t("common.delete")} ${t("settings.auctions.locations.location")}`}
        body={t("confirmation.deleteMessage", {
          module: t("settings.auctions.locations.location"),
        })}
        actionBtnTitle={`${t("common.delete")}`}
        loader={languageDeleteLoader}
        isModalOpen={isDeleteLocationModalOpen}
        onConfirmBtnHandler={handleConfirmBtn}
        onCloseBtnHandler={handleCloseBtn}
      />
    </>
  );
};

export default withTranslation()(AuctionLocation);
